
import MENU_AU from './weddingvenues.au.json'
import MENU_UK from './weddingvenues.uk.json'

type WeddingVenuesDataType = {
  [key in 'au' | 'uk']: {
    popular_styles: [{
      title: string
      url: string
      image: string
    }]
    popular_regions: [{
      title: string
      url: string
      target?: string
    }]
  }
}

export default {
  'au': MENU_AU,
  'uk': MENU_UK,
} as WeddingVenuesDataType